import { memo } from "react";
import Icon from "./Icon";

interface Props {
  size?: number;
}

const AdminIcon = ({ size = 12 }: Props) => {
  return <Icon icon="star" filled color={"#1C1B1F"} size={size} />;
};

export default memo(AdminIcon);
